/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
export enum InsuranceControlActionLinkVersionEnum {
    Old,
    Params,
    Fragment,
    New,
}
